import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import {useChapterStatuses} from '#hooks/store/useChapterStatuses'
import AusbildungsplanAzubiListMenu from './AusbildungsplanAzubiListMenu'
import AusbildungsplanQuestionSets from './AusbildungsplanQuestionSets'
import AusbildungsplanContentMenu from './AusbildungsplanContentMenu'
import {useAusbildungsplan} from '#hooks/useAusbildungsplan'

function AusbildungsplanSubmenuAsAusbilder(props) {
  const {pathParts, currentUserId, contextualUserId} = props

  const {getStaticContent, ready, getQuestionsContent, findParent} = useAusbildungsplan(contextualUserId)
  const {hasSubmittedChapters, isChapterSubmitted} = useChapterStatuses(contextualUserId)

  const isInAzubiContext = currentUserId !== contextualUserId
  const isQuestionsContent = pathParts.includes('questions')

  const getLevel1Menu = () => (isInAzubiContext ? 'left' : '')
  const getLevel2Menu = () => {
    if (!isInAzubiContext) {
      return 'right'
    }
    if (isQuestionsContent) {
      return 'left'
    }
    return ''
  }

  const getLevel3Menu = () => (!isQuestionsContent ? 'right' : '')
  return (
    <>
      <div className={`menu-partial ${getLevel1Menu()}`}>
        <AusbildungsplanAzubiListMenu hasSubmittedChapters={hasSubmittedChapters} />
      </div>
      <AusbildungsplanContentMenu
        pageList={getStaticContent()}
        chapters={getQuestionsContent()}
        contextualUserId={contextualUserId}
        pathParts={pathParts}
        levelMenu={getLevel2Menu}
      />
      <div className={`menu-partial ${getLevel3Menu()}`}>
        <AusbildungsplanQuestionSets
          ready={ready}
          findParent={findParent}
          contextualUserId={contextualUserId}
          currentItem={pathParts[3]}
          isChapterSubmitted={isChapterSubmitted}
        />
      </div>
    </>
  )
}

AusbildungsplanSubmenuAsAusbilder.propTypes = {
  pathParts: PropTypes.array.isRequired,
  currentUserId: PropTypes.number.isRequired,
  contextualUserId: PropTypes.number,
}

export default AusbildungsplanSubmenuAsAusbilder
